import React from 'react'
function Footer() {
    return (
        <div style={{top:'95'}}>
            <span className="price__date">
            For more information, contact 
            <span style={{fontWeight:'bold',paddingLeft:'10px'}}>
             <a href='https://github.com/imdp7' style={{color:'#FF5000'}}>Darshan Patel </a>
             </span>
             </span>
        </div>
    )
}

export default Footer
